import { inject, Injectable } from '@angular/core';
import { User } from '../../../models/user/user';
import { UserPic } from '../../../models/user/user-pic';
import { UserApiService } from '../../repository/flexseat/user-api.service';
import { UserGraph } from '../../repository/util/graph/graph-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly userApi = inject(UserApiService);

  /**
   * Send user informations to DB.
   * @returns a Promise resolves when the operation succeeds or if there's an error during the API request
   */
  sendUser(user: User): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userApi.upsertUser(user).subscribe({
        next: () => {
          resolve();
        },
        error: (error) => {
          console.error('Error sending user:', error);
          reject(error);
        }
      });
    });
  }
  /**
   * Gets user profile picture from Microsoft Graph and send to API
   * @returns a Promise resolves when the operation succeeds or if there's an error during the API request
   */
  sendUserPic(userPic: UserPic): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userApi.upsertUserPic(userPic).subscribe({
        next: () => {
          resolve();
        },
        error: (error) => {
          console.error('Error sending user pic:', error);
          reject(error);
        }
      });
    });
  }
  /** Gets user information and the picture retrieved from Microsoft Graph and send to API
   * @returns a Promise resolves when the operation succeeds or if there's an error during the API request
   */
  sendUserData(userGraph: UserGraph, userPic: string): Promise<void>{
    
    const user: User = {
      username: userGraph.employeeId,
      empname: userGraph.displayName,
      email: userGraph.mail,
      area: userGraph.department,
      lastsession: new Date()
    };

    const pic: UserPic = {
      username: userGraph.employeeId,
      picture: userPic.split(',')[1]
    };

    return new Promise(async (resolve, reject) => {
      try {
        await this.sendUser(user);
        await this.sendUserPic(pic);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
  
}
